import React, { useState, useEffect } from 'react';
import { Utilities } from '../utils/Utilities';
import { YoutubeManager } from '../utils/YoutubeManager';
import type { YouTubeVideoItem } from '../types/youtube';

function safeTitle(item: YouTubeVideoItem) {
    return Utilities.decodeHtmlEntities(item.title);
}

interface TrendingVideosProps {
    count: number;
    title?: string;
}

function TrendingVideos({ count, title = 'Trending Videos' }: TrendingVideosProps) {
    const [videos, setVideos] = useState<YouTubeVideoItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadVideos = async () => {
            try {
                const videoItems = await YoutubeManager.getInstance().fetchYouTubeVideos(count + 2, 'viewcount');
                setVideos(videoItems.slice(2));
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        loadVideos();
    }, [count]);

    if (loading) {
        return (
            <div className="trending">
                <h3>{title}</h3>
                <div className="trending-post p-4">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="trending">
                <h3>{title}</h3>
                <div className="trending-post p-4 text-danger">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="trending trending-videos">
            <h3>{title}</h3>
            <ul className="trending-post">
                {videos.map((item) => (
                    <li key={item.videoId}>
                        <a
                            href={`https://www.youtube.com/watch?v=${item.videoId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="number">{item.number-2}</span>
                            <div className="trending-video-item">
                                <img
                                    src={item.thumbnail}
                                    alt={safeTitle(item)}
                                    className="trending-video-thumbnail"
                                />
                                <div className="trending-video-title-overlay">
                                    <h3>{safeTitle(item)}</h3>
                                </div>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default TrendingVideos;
